import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { parseHtmlToReact, parseJson, prepareForParse } from '../../utils'

function CustomCampusnewsList({
  data: { pageContext, ...pageData },
  // component props
  label = '',
  limit = undefined,
}) {
  const { locale, publishYear = '' } = pageContext
  // Template 取得
  // 本来であれば variables で絞り込みたいが、制約がありできない
  // https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/#known-limitations
  const data = useStaticQuery(graphql`
    query {
      allContentfulTemplate(filter: { name: { eq: "customCampusnewsList" } }) {
        nodes {
          contentful_id
          __typename
          node_locale
          name
          body {
            raw
          }
          context {
            internal {
              content
            }
          }
        }
      }
    }
  `)
  const template = data.allContentfulTemplate.nodes.find(
    (node) => node.node_locale === locale
  )
  if (template === undefined) {
    throw new Error(`Template not found: ${locale}`)
  }

  const { categoryList = {} } =
    parseJson(template.context?.internal?.content) ?? {}

  // component props の label には複数ラベルを設定可能
  const filterLabels = label.split(',').filter((item) => item !== '')

  const informationList = pageData.allContentfulCampusnews.nodes
    .filter((node) => node.node_locale === locale)
    .filter(
      (node) => filterLabels.length === 0 || filterLabels.includes(node.label)
    )
    .filter((node) => publishYear === '' || node.publishYear === publishYear)
    .slice(0, limit)

  if (informationList.length > 0) {
    return informationList.map((node, index) => {
      const { htmlBody, componentData } = prepareForParse({
        template,
        data: {
          ...pageData,
          // customInformationList 向けの CustomTemplateText を共用する
          contentfulInformation: node,
          context: {
            categoryName: categoryList?.[node.label],
          },
        },
        pageContext,
      })

      return (
        <React.Fragment key={index}>
          {parseHtmlToReact(htmlBody, componentData)}
        </React.Fragment>
      )
    })
  } else {
    return null
  }
}

export { CustomCampusnewsList }
